import React from 'react';
// Bundled copy of the mobile app icon (nubod-mobile/assets/logo-app.png,
// downscaled). The old CDN URL answered with an HTML page, so the card
// silently rendered without its icon.
import appIcon from '../../assets/logos/nubod-app-icon.png';

const APP_STORE_URL = 'https://apps.apple.com/us/app/nubod/id6759975198';

/**
 * The "download the Nubod app" card — Nubod app icon, a short pitch, and the
 * App Store badge. Shared by the client assessment-completed screen and the
 * trainer welcome screen so both stay in sync. Pass `title` / `subcopy` to
 * tailor the wording per audience (defaults are the client wording).
 *
 * iOS only — there is no Android Play Store URL in the app yet; add a second
 * badge here when one exists so every caller picks it up.
 */
export default function AppDownloadCard({
  title = 'Get more out of Nubod on your phone',
  subcopy = 'Track workouts, log meals, submit check-ins, and stay connected with your trainer — all from your pocket.',
}) {
  return (
    <div
      className='card'
      style={{ padding: '24px 20px', marginBottom: 20, textAlign: 'center' }}
    >
      <img
        src={appIcon}
        alt='Nubod app'
        style={{
          width: 64,
          height: 64,
          borderRadius: 14,
          marginBottom: 16,
          boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
        }}
      />
      <p
        style={{
          fontSize: 15,
          fontWeight: 600,
          color: 'var(--fg)',
          marginBottom: 6,
        }}
      >
        {title}
      </p>
      <p
        style={{
          fontSize: 13,
          color: 'var(--fg-muted)',
          marginBottom: 20,
          lineHeight: 1.5,
        }}
      >
        {subcopy}
      </p>
      <a
        href={APP_STORE_URL}
        target='_blank'
        rel='noopener noreferrer'
        style={{ display: 'inline-block' }}
      >
        <img
          src='https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg'
          alt='Download on the App Store'
          style={{ height: 44 }}
        />
      </a>
    </div>
  );
}
